export default __webpack_public_path__ + "static/media/pt.7e5d0dcb.svg";